import React from "react";
// UI Frameworks
import AddIcon from "@mui/icons-material/Add";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { Modal } from "src/Components";
// Local Components
import { Additional } from "./StrategyAdditional";
import AddEditStrategyModal from "./AddEditStrategyModal";
// Services
import { getStrategyTable } from "src/Requests/deltaHedgeAccounts";

const Strategy: React.FC = () => {
  // states
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [isAddVisible, setIsAddVissible] = React.useState(false);

  return (
    <div className="flex flex-col items-end gap-5 w-full">
      {isAddVisible ? (
        <Modal
          title="افزودن استراتژی"
          UI={
            <AddEditStrategyModal
              onClose={() => setIsAddVissible(false)}
              onSuccess={() => setRefreshFlag(true)}
            />
          }
          onClose={() => setIsAddVissible(false)}
          modalBoxClassName="!min-w-min"
        />
      ) : (
        <></>
      )}
      <div
        className="bg-sky-600 rounded-full flex justify-center items-center !w-11 !h-11 cursor-pointer"
        onClick={() => setIsAddVissible(true)}
      >
        <AddIcon className="text-white" />
      </div>
      <TableTemplate
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            AdditionalBody={Additional}
            onAction={onAction}
            refreshFlag={refreshFlag}
          />
        )}
        getDataTable={getStrategyTable}
      />
    </div>
  );
};

export default Strategy;
